import React from "react";
import Select, { selectComponents } from "../../../common/select.jsx";

function ProviderFilter({ selectedProviders, providers, onChange, multiSelect = false }) {
  React.useEffect(() => {
    let patched = false;
    let fixedSelectedList = selectedProviders.map((provider) => {
      let label = provider.label;
      if (!label) {
        label = providers.find((prov) => prov.provider_guid === provider.value)?.provider_name ?? "-";

        if (label !== "-") {
          patched = true;
        }
      }

      return {
        value: provider.value ?? "",
        label,
      };
    });

    if (patched) {
      onChange(fixedSelectedList);
    }
  }, [selectedProviders, onChange, providers]);

  return (
    <Select
      isSearchable={true}
      placeholder={"Provider"}
      name={"provider"}
      options={providers.map((p) => ({
        label: p.provider_name,
        value: p.provider_guid,
      }))}
      value={selectedProviders}
      onChange={(input) => onChange(multiSelect ? input : [input])}
      containerClass="react-select-container--light react-select-container--small"
      isMulti={multiSelect}
      components={{
        ClearIndicator: () => null,
        MultiValueRemove: (props) =>
          props.selectProps.value.length > 1 ? <selectComponents.MultiValueRemove {...props} /> : null, // removes x when only one item
      }}
    />
  );
}

export default ProviderFilter;
